import PageReloadOverlay from 'modules/Conference/components/Overlay/PageReloadOverlay';
import SuspendedOverlay from 'modules/Conference/components/Overlay/SuspendedOverlay';
import UserMediaPermissionsOverlay from 'modules/Conference/components/Overlay/UserMediaPermissionsOverlay';
import CameraLostOverlay from 'modules/Conference/components/Overlay/CameraLostOverlay';

/**
 * Returns the list of available platform specific overlays.
 *
 * @returns {Array<Object>}
 */
export function getOverlays() {
  return [
    PageReloadOverlay,
    SuspendedOverlay,
    CameraLostOverlay,
    UserMediaPermissionsOverlay
  ];
}
